/* Sticky buy bar visibility and variant sync. */
(function () {
  'use strict';

  const H = window.Hystride;
  if (!H) return;

  H.register('sticky-buy-bar', {
    mount(root) {
      // Watch a dedicated anchor rather than the buy button. If the button is
      // hidden — sold out, or moved by the merchant — an observer on it either
      // never fires or never stops firing.
      const anchor =
        document.querySelector('[data-hys-buy-anchor]') || document.querySelector('.pdp');
      const footer = document.querySelector('footer');
      if (!anchor) return null;

      const image = root.querySelector('[data-bb-image]');
      const variantEl = root.querySelector('[data-bb-variant]');
      const priceEl = root.querySelector('[data-bb-price]');
      const submit = root.querySelector('[data-bb-submit]');

      let pastBuyBlock = false;
      let atFooter = false;

      // "Show on" setting: all / mobile / desktop. Mobile = below 750px (Horizon's breakpoint).
      const mode = root.dataset.visibility || 'all';
      const mobile = window.matchMedia('(max-width: 749px)');
      const allowed = () => mode === 'all' || (mode === 'mobile') === mobile.matches;

      const sync = () => {
        const show = allowed() && pastBuyBlock && !atFooter;
        root.classList.toggle('on', show);
        // Slid away it is only translated, so without inert the button is still
        // tab-reachable while invisible.
        root.toggleAttribute('inert', !show);
        document.body.classList.toggle('bb-on', show);
        // The chat bubble sits above the bar; publish the real height rather
        // than assuming 74px.
        document.documentElement.style.setProperty(
          '--bb-h',
          show ? `${Math.round(root.getBoundingClientRect().height)}px` : '0px'
        );
      };

      const observers = [];

      if ('IntersectionObserver' in window) {
        const chrome = H.chromeHeight();
        const buyIo = new IntersectionObserver(
          ([entry]) => {
            pastBuyBlock = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sync();
          },
          { rootMargin: `-${chrome}px 0px 0px 0px` }
        );
        buyIo.observe(anchor);
        observers.push(buyIo);

        if (footer) {
          const footIo = new IntersectionObserver(
            ([entry]) => {
              atFooter = entry.isIntersecting;
              sync();
            },
            { rootMargin: '0px 0px -10% 0px' }
          );
          footIo.observe(footer);
          observers.push(footIo);
        }
      }

      // The bar has to follow the variant like everything else — its price is
      // pinned in the markup in the prototype and never changes with anything.
      const onVariant = (e) => {
        const v = e.detail;
        if (!v) return;
        if (priceEl) priceEl.textContent = v.price;
        if (variantEl) variantEl.textContent = v.title;
        if (image && v.featured_image) image.src = v.featured_image;
        if (submit) submit.disabled = !v.available;
      };
      document.addEventListener('hystride:variant', onVariant);

      const onChrome = () => sync();
      document.addEventListener('hystride:chrome-height', onChrome);
      mobile.addEventListener('change', onChrome);

      sync();

      return { observers, onVariant, onChrome, mobile };
    },

    unmount(root, s) {
      if (!s) return;
      s.observers.forEach((io) => io.disconnect());
      document.removeEventListener('hystride:variant', s.onVariant);
      document.removeEventListener('hystride:chrome-height', s.onChrome);
      s.mobile.removeEventListener('change', s.onChrome);
      document.body.classList.remove('bb-on');
    },
  });
})();
